import { Severity } from '../../../../../common/enums/Severity';

export class Issue {
  constructor(
    private readonly issueNumber: number,
    private readonly title: string,
    private readonly shortExplanation: string,
    private readonly severity: Severity,
    private readonly projectsImpacted: number,
    private readonly reportsImpacted: number
  ) {}

  getNumber() {
    return this.issueNumber;
  }

  getTitle() {
    return this.title;
  }

  getShortExplanation() {
    return this.shortExplanation;
  }

  getSeverity() {
    return this.severity;
  }

  getProjectsImpacted() {
    return this.projectsImpacted;
  }

  getReportsImpacted() {
    return this.reportsImpacted;
  }
}
